import '@fortawesome/fontawesome-free/css/all.css'
import {closeAllDropdownLists} from '@/Helpers/general'

(function():void{
	// On page load or when changing themes, best to add inline in `head` to avoid FOUC
	if(localStorage.getItem('theme') === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)){
		document.documentElement.classList.add('dark')
	} else {
		document.documentElement.classList.remove('dark')
	}

	document.addEventListener('click', function(evt:MouseEvent):void{
		if(evt.target && evt.target instanceof Element){
			if(!evt.target.classList.contains('dropdown-list')){
				evt.stopPropagation()
				closeAllDropdownLists()
			}
		}
	})
})()